import React from 'react';
import { get, set } from 'lodash';
import { usePlanningBottomupState } from '../Context/index';
import { FPKeysPath } from '../TablesFieldPath';
import { checkIsNumber } from '../../../Components/helper';
import useMdCalculationHooks from '../Hooks/MdHooks';

export function FPTable() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel, selectedDisplayColumn } = planningBottomup;
  const level = selectedLevel?.level || 0;

  const { calculateMd } = useMdCalculationHooks();

  const fpFields = [
    {
      keyName: 'fpSalesUnits',
      name: 'FP Sales Units',
    },
    // {
    //   keyName: "fpSalesValue",
    //   name: "FP Sales Value",
    // },
    {
      keyName: 'fpSlsMix',
      name: 'FP Sls Mix %',
    },
  ];

  const handleChange = async (text, path, index) => {
    const copyState = planningBottomProducts;
    set(copyState, path, text);
    const currenObj1 = get(copyState, index);
    copyState[index] = await calculateMd(currenObj1);
    setPlanningBottomup((prevState) => ({
      ...prevState,
      planningBottomProducts: copyState,
    }));
  };

  const includeLevel = [6];
  const isTableVisible = fpFields.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {fpFields?.map((fpFielsItem, i) => {
              const isVisible = checkVisibleBottomUp(fpFielsItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{fpFielsItem.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {planningBottomProducts?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {fpFields?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <>
                        {tdItem.keyName === 'fpSlsMix' ? (
                          <td key={iTD}>
                            {level === 6 ? (
                              <div className="d-flex align-items-center">
                                {' '}
                                <input
                                  type="text"
                                  className="form-control text-bordered"
                                  onChange={(e) => {
                                    if (checkIsNumber(e.target.value)) {
                                      handleChange(e.target.value, FPKeysPath(iParent, tdItem?.keyName).FPKEYS, iParent);
                                    }
                                  }}
                                  value={trItem?.fpSlsMix?.value}
                                  disabled={!includeLevel.includes(level) || !planningBottomup?.addEditBottomAccess}
                                />
                                <span className="ml-1">%</span>
                              </div>
                            ) : (
                              `${trItem?.fpSlsMix?.value || 0}%`
                            )}
                          </td>
                        ) : (
                          <td key={iTD} className="text-right">
                            {trItem[tdItem.keyName] || 0}
                          </td>
                        )}
                      </>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default FPTable;
